export default "__VITE_ASSET__CDDGkxhs__"